import * as React from 'react';
import {tokens} from '@packages/utilities/styled';

import {ROW_ITEM_BODY_MIN_HEIGHT} from '../../RowItem/RowItemBody/RowItemBody.styles';
import {RowItemProps} from '../../RowItem';
import {Text} from '../../Text';
import {View} from '../../View';
import {useSearchableListContext} from '../useSearchableList';

const defaultRenderEmptyStateLabel = () => 'No results';

const SearchableListEmptyState = React.forwardRef<
  HTMLDivElement,
  {density: NonNullable<RowItemProps['density']>}
>(({density}, ref) => {
  const {renderEmptyStateLabel: renderEmptyStateLabelProp} =
    useSearchableListContext();

  const renderEmptyStateLabel = React.useMemo(
    () => renderEmptyStateLabelProp ?? defaultRenderEmptyStateLabel,
    [renderEmptyStateLabelProp]
  );

  return (
    <View
      alignContent="center"
      margin={`${tokens.ui.rowItem.padding[density].vertical} ${tokens.ui.rowItem.padding[density].left}`}
      minHeight={ROW_ITEM_BODY_MIN_HEIGHT}
      ref={ref}
    >
      <Text colorVariant="secondary">{renderEmptyStateLabel()}</Text>
    </View>
  );
});

export default SearchableListEmptyState;
